import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} categories
 * @returns {Workbook}
 */
export const exportExcel = async (categories) => {
  categories.forEach((category, index) => (category.order = index + 1));

  const json = excelHelper.jsonToJson(
    [categories],
    [
      {
        name: "CATEGORIAS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-categorias.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Category/CategoryList/excel.js